import {apiFetch} from 'lib/fetch'
import type {ShowType} from 'types/showType'
import {getApiUrl} from '../urls'

export const list = async (): Promise<ShowType[]> =>
  apiFetch.get<ShowType[]>(getApiUrl('showTypes'), {simple: 'true'})
